import RegisteredUsers from "../../../jsx/components/Dashboard/RegisteredUsers/registeredUsers";

const RegisteredUsersWrapper = () => {
  return <RegisteredUsers />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(RegisteredUsersWrapper);
